// extracted by mini-css-extract-plugin
module.exports = {"TooltipIcon_iconWrapper":"IconTooltip__TooltipIcon_iconWrapper__2vEo1","TooltipIcon_iconWrapper_icon":"IconTooltip__TooltipIcon_iconWrapper_icon__1Sbne"};